import React from 'react';

const CategoryPage = () => (
  <div>Under construction...</div>
);

export default CategoryPage;
